<div class="header-container">
  <div class="nav-back" (click)="navigateToPage()" *ngIf="goToPageText">
      <div class="nav-arrow"></div>
      <div class="nav-text">{{goToPageText}}</div>
  </div>
  <div (click)="goToHome()" style="position: absolute; left: 50%; top:10px; transform: translateX(-50%);">
    <img src="assets/images/Logo.png" class="logo-image" />
  </div>
</div>